import { Heading, Text } from "@/design-system";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router";
import { type BlogLink, TOOLS, type ToolKey } from "../constants";

type RelatedLinksProps = {
  /** A ferramenta da página: some da lista de "outras ferramentas". */
  current: ToolKey;
  posts: BlogLink[];
};

const linkClassName =
  "group rounded-ds-lg border-ds-border bg-ds-surface hover:border-ds-brand-300 hover:bg-ds-brand-50 focus-visible:outline-ds-focus flex min-h-11 cursor-pointer items-start justify-between gap-3 border p-4 transition-colors focus-visible:outline-2 motion-reduce:transition-none";

/** Links internos do fim da ferramenta: o post que explica e as ferramentas irmãs. */
export const RelatedLinks = ({ current, posts }: RelatedLinksProps) => (
  <section
    aria-labelledby="relacionados-title"
    className="mx-auto flex w-full max-w-6xl flex-col gap-6 px-4 sm:px-6 lg:px-8 print:hidden"
  >
    <Heading level={2} size={3} id="relacionados-title">
      Continue por aqui
    </Heading>
    <div className="grid gap-6 md:grid-cols-2">
      <div className="flex flex-col gap-3">
        <Text size="small" tone="subtle" weight="semibold">
          No blog da Fidexa
        </Text>
        <ul className="flex flex-col gap-3">
          {posts.map(post => (
            <li key={post.path}>
              <Link to={post.path} className={linkClassName}>
                <Text as="span" weight="medium">
                  {post.title}
                </Text>
                <ArrowRight
                  aria-hidden="true"
                  className="text-ds-brand-700 mt-1 size-4 shrink-0"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-3">
        <Text size="small" tone="subtle" weight="semibold">
          Outras ferramentas grátis
        </Text>
        <ul className="flex flex-col gap-3">
          {TOOLS.filter(tool => tool.key !== current).map(tool => (
            <li key={tool.key}>
              <Link to={tool.path} className={linkClassName}>
                <span className="flex flex-col gap-1">
                  <Text as="span" weight="semibold">
                    {tool.name}
                  </Text>
                  <Text as="span" size="small" tone="subtle">
                    {tool.summary}
                  </Text>
                </span>
                <ArrowRight
                  aria-hidden="true"
                  className="text-ds-brand-700 mt-1 size-4 shrink-0"
                />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
